export { default as en } from './en';
export { default as ru } from './ru';
export { default as zh } from './zh';
export { default as ko } from './ko';
export { default as ja } from './ja';
export { default as fr } from './fr';



// WEBPACK FOOTER //
// ./src/locales/index.js